<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Reporte CEAA</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="text-capitalize" small tile :loading="cargando" @click="initialize">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-tabs v-model="tab" class="px-4" color="primary" height="40">
            <v-tab class="text-capitalize">
              Paquetes
              <v-chip v-if="pendientes.length" x-small dark color="blue-grey" class="ml-2">{{ pendientes.length }}</v-chip>
            </v-tab>
            <v-tab class="text-capitalize">Reporte</v-tab>
          </v-tabs>
          <v-divider />

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-text>
                <div class="text-caption grey--text text--darken-1 mb-3">
                  Cada vez que CEAA acepta comisiones se forma un paquete. Abre un paquete para generar su requisición.
                  Queda pagado cuando la requisición está Procesada y el egreso queda Autorizado.
                </div>

                <v-row>
                  <v-col v-for="tarjeta in resumenPaquetes" :key="tarjeta.estatus" cols="12" md="4">
                    <v-card
                      outlined
                      class="pa-3 d-flex align-center resumen-card"
                      :class="{ 'resumen-card--activa': filtroPaquetes === tarjeta.estatus }"
                      @click="filtroPaquetes = filtroPaquetes === tarjeta.estatus ? null : tarjeta.estatus"
                    >
                      <v-avatar size="38" :color="colorPaquete(tarjeta.estatus)" class="mr-3">
                        <v-icon color="white" small>{{ tarjeta.icon }}</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-caption grey--text text--darken-1">{{ textoPaquete(tarjeta.estatus) }}</div>
                        <div class="text-body-1 font-weight-bold">
                          {{ tarjeta.cantidad }} · {{ moneda(tarjeta.monto) }}
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headersPaquetes"
                  :items="paquetesFiltrados"
                  item-key="id"
                  class="elevation-0 mt-4 fila-clic"
                  :loading="cargando"
                  dense
                  :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }"
                  @click:row="item => verPaquete(item.id)"
                >
                  <template v-slot:item.id="{ item }"><b>#{{ item.id }}</b></template>
                  <template v-slot:item.fecha="{ item }">{{ formatoFechaHora(item.fecha) }}</template>
                  <template v-slot:item.monto="{ item }">{{ moneda(item.monto) }}</template>
                  <template v-slot:item.id_requisicion="{ item }">
                    <span v-if="item.id_requisicion">#{{ item.id_requisicion }} · {{ item.requisicion_estatus || 'Sin estatus' }}</span>
                    <span v-else class="grey--text">Sin requisición</span>
                  </template>
                  <template v-slot:item.pagadas="{ item }">{{ item.pagadas }} de {{ item.cantidad }}</template>
                  <template v-slot:item.estatus="{ item }">
                    <v-chip small dark :color="colorPaquete(item.estatus)">{{ textoPaquete(item.estatus) }}</v-chip>
                    <v-tooltip v-if="item.no_disponibles" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="orange darken-2" class="ml-1" v-bind="attrs" v-on="on">mdi-alert-outline</v-icon>
                      </template>
                      <span>{{ item.no_disponibles }} comisión(es) ya no aparecen como alumno inscrito</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.acciones>
                    <v-icon small color="primary">mdi-chevron-right</v-icon>
                  </template>
                  <template v-slot:no-data>
                    <span class="grey--text">Sin paquetes</span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-tab-item>

            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="filtros.contactoDesde" label="Contacto desde" type="date" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="filtros.contactoHasta" label="Contacto hasta" type="date" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="filtros.inscripcionDesde" label="Inscripción desde" type="date" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="filtros.inscripcionHasta" label="Inscripción hasta" type="date" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select v-model="filtros.estatus" :items="opcionesEstatus" label="Estatus" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select v-model="filtros.decision" :items="opcionesDecision" label="Decisión" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select v-model="filtros.pago" :items="opcionesPago" label="Pagada" filled dense hide-details clearable />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="search" label="Buscar" filled dense hide-details append-icon="mdi-magnify" clearable />
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="filas"
                  item-key="telefono"
                  class="elevation-0 mt-4"
                  :search="search"
                  :loading="cargando"
                  dense
                  :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
                >
                  <template v-slot:item.fecha_contacto="{ item }">{{ formatoFecha(item.fecha_contacto) }}</template>
                  <template v-slot:item.fecha_inscripcion="{ item }">{{ formatoFecha(item.fecha_inscripcion) }}</template>
                  <template v-slot:item.fecha_pago="{ item }">
                    <v-chip v-if="item.pago_alumno === 'por_validar'" small dark color="orange darken-1">
                      Falta de validación
                    </v-chip>
                    <span v-else>{{ formatoFecha(item.fecha_pago) }}</span>
                  </template>
                  <template v-slot:item.estatus="{ item }">
                    <v-chip small dark :color="item.estatus === 'inscrito' ? 'green' : 'grey'">
                      {{ item.estatus === 'inscrito' ? 'Inscrito' : 'Solo contacto' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.comision="{ item }">{{ moneda(item.comision) }}</template>
                  <template v-slot:item.decision="{ item }">
                    <span v-if="item.estatus !== 'inscrito' || item.pago_alumno !== 'validado'" class="grey--text">—</span>
                    <v-tooltip v-else-if="item.decision === 'rechazada' && item.notas" bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip small dark color="red" v-bind="attrs" v-on="on">
                          Rechazada
                          <v-icon right x-small>mdi-note-text-outline</v-icon>
                        </v-chip>
                      </template>
                      <span>{{ item.notas }}</span>
                    </v-tooltip>
                    <v-chip v-else small dark :color="colorDecision(item.decision)">
                      {{ textoDecision(item.decision) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.id_paquete="{ item }">
                    <a v-if="item.id_paquete" class="text-no-wrap" @click="verPaquete(item.id_paquete)">#{{ item.id_paquete }}</a>
                    <span v-else class="grey--text">—</span>
                  </template>
                  <template v-slot:item.pago="{ item }">
                    <v-chip small dark :color="item.pago === 'pagada' ? 'green' : 'orange'">
                      {{ item.pago === 'pagada' ? 'Pagada' : 'No pagada' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.requisicion_estatus="{ item }">
                    <span v-if="item.id_requisicion">#{{ item.id_requisicion }} · {{ item.requisicion_estatus || 'Sin estatus' }}</span>
                    <span v-else class="grey--text">Sin requisición</span>
                  </template>
                  <template v-slot:item.egreso_validado="{ item }">
                    <v-chip v-if="item.id_requisicion" small dark :color="item.egreso_validado ? 'green' : 'grey'">
                      {{ item.egreso_validado ? 'Validado' : 'Sin validar' }}
                    </v-chip>
                    <span v-else class="grey--text">—</span>
                  </template>
                  <template v-slot:no-data>
                    <span class="grey--text">Sin contactos con estos filtros</span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="detalle.visible" max-width="1000">
      <v-card v-if="paqueteDetalle">
        <v-card-title class="text-subtitle-1">
          Paquete #{{ paqueteDetalle.id }}
          <v-chip small dark class="ml-3" :color="colorPaquete(paqueteDetalle.estatus)">
            {{ textoPaquete(paqueteDetalle.estatus) }}
          </v-chip>
          <v-spacer />
          <v-btn icon small @click="detalle.visible = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense class="mb-2">
            <v-col v-for="dato in datosPaquete" :key="dato.titulo" cols="6" md="3">
              <div class="text-caption grey--text text--darken-1">{{ dato.titulo }}</div>
              <div class="text-body-2 font-weight-bold">{{ dato.valor }}</div>
            </v-col>
          </v-row>

          <v-alert
            v-if="paqueteDetalle.estatus === 'pendiente_requisicion' && paqueteDetalle.no_disponibles"
            type="warning"
            dense
            text
            class="text-body-2"
          >
            {{ paqueteDetalle.no_disponibles }} comisión(es) de este paquete ya no aparecen como alumno inscrito.
            Revisa esos alumnos antes de generar la requisición.
          </v-alert>

          <v-data-table
            :headers="headersDetalle"
            :items="paqueteDetalle.comisiones"
            item-key="telefono"
            class="elevation-0"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.alumno="{ item }">{{ item.alumno || item.nombre }}</template>
            <template v-slot:item.estatus="{ item }">
              <v-chip x-small dark :color="item.estatus === 'inscrito' ? 'green' : 'grey'">
                {{ item.estatus === 'inscrito' ? 'Inscrito' : 'Solo contacto' }}
              </v-chip>
            </template>
            <template v-slot:item.fecha_pago="{ item }">{{ formatoFecha(item.fecha_pago) }}</template>
            <template v-slot:item.comision="{ item }">{{ moneda(item.comision) }}</template>
            <template v-slot:item.egreso_validado="{ item }">
              <v-chip v-if="item.id_requisicion" x-small dark :color="item.egreso_validado ? 'green' : 'grey'">
                {{ item.egreso_validado ? 'Validado' : 'Sin validar' }}
              </v-chip>
              <span v-else class="grey--text">—</span>
            </template>
            <template v-slot:item.pago="{ item }">
              <v-chip x-small dark :color="item.pago === 'pagada' ? 'green' : 'orange'">
                {{ item.pago === 'pagada' ? 'Pagada' : 'No pagada' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions v-if="paqueteDetalle.estatus === 'pendiente_requisicion'">
          <v-spacer />
          <v-btn
            color="primary"
            :dark="!paqueteDetalle.no_disponibles"
            class="text-capitalize"
            small
            tile
            :disabled="!!paqueteDetalle.no_disponibles"
            @click="confirmacion = true"
          >
            <v-icon left small>mdi-file-document-outline</v-icon>
            Generar requisición
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmacion" max-width="460" persistent>
      <v-card v-if="paqueteDetalle">
        <v-card-title class="text-subtitle-1">Generar requisición</v-card-title>
        <v-card-text class="black--text">
          ¿Generar la requisición del paquete <b>#{{ paqueteDetalle.id }}</b> con
          <b>{{ paqueteDetalle.cantidad }}</b> {{ paqueteDetalle.cantidad === 1 ? 'partida' : 'partidas' }}
          por <b>{{ moneda(paqueteDetalle.monto) }}</b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="generando" @click="confirmacion = false">Cancelar</v-btn>
          <v-btn color="primary" dark :loading="generando" @click="generarRequisicion">Generar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargando || generando" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

function enRango(valor, desde, hasta) {
  if (!desde && !hasta) return true
  if (!valor) return false
  const dia = String(valor).slice(0, 10)
  if (desde && dia < desde) return false
  if (hasta && dia > hasta) return false
  return true
}

export default {
  name: 'ReporteCEAA',

  mixins: [validarErrores],

  components: { Alerta, carga },

  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargando: false,
    generando: false,
    tab: 0,
    search: '',
    contactos: [],
    paquetes: [],
    filtroPaquetes: null,
    detalle: { visible: false, id: null },
    confirmacion: false,
    filtros: {
      contactoDesde: null,
      contactoHasta: null,
      inscripcionDesde: null,
      inscripcionHasta: null,
      estatus: null,
      decision: null,
      pago: null,
    },
    opcionesEstatus: [
      { text: 'Inscrito', value: 'inscrito' },
      { text: 'Solo contacto', value: 'solo_contacto' },
    ],
    opcionesDecision: [
      { text: 'Pendiente', value: 'pendiente' },
      { text: 'Aceptada', value: 'aceptada' },
      { text: 'Rechazada', value: 'rechazada' },
    ],
    opcionesPago: [
      { text: 'Pagada', value: 'pagada' },
      { text: 'No pagada', value: 'no_pagada' },
    ],
    headersPaquetes: [
      { text: 'Paquete', value: 'id' },
      { text: 'Fecha de aceptación', value: 'fecha' },
      { text: 'Comisiones', value: 'cantidad' },
      { text: 'Monto', value: 'monto' },
      { text: 'Requisición', value: 'id_requisicion' },
      { text: 'Pagadas', value: 'pagadas' },
      { text: 'Estatus', value: 'estatus' },
      { text: '', value: 'acciones', sortable: false, width: 40 },
    ],
    headersDetalle: [
      { text: 'Alumno', value: 'alumno' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Pago del alumno', value: 'fecha_pago' },
      { text: 'Comisión', value: 'comision' },
      { text: 'Egreso', value: 'egreso_validado', sortable: false },
      { text: 'Pago', value: 'pago' },
    ],
    headers: [
      { text: 'Contacto', value: 'fecha_contacto' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Folio', value: 'folio' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'ID alumno', value: 'id_alumno' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Inscripción', value: 'fecha_inscripcion' },
      { text: 'Pago del alumno', value: 'fecha_pago' },
      { text: 'Comisión', value: 'comision' },
      { text: 'Decisión', value: 'decision' },
      { text: 'Paquete', value: 'id_paquete' },
      { text: 'Requisición', value: 'requisicion_estatus' },
      { text: 'Egreso', value: 'egreso_validado', sortable: false },
      { text: 'Pago', value: 'pago' },
    ],
  }),

  computed: {
    filas() {
      const f = this.filtros
      return this.contactos.filter(item =>
        enRango(item.fecha_contacto, f.contactoDesde, f.contactoHasta)
        && enRango(item.fecha_inscripcion, f.inscripcionDesde, f.inscripcionHasta)
        && (!f.estatus || item.estatus === f.estatus)
        && (!f.decision || item.decision === f.decision)
        && (!f.pago || item.pago === f.pago)
      )
    },

    pendientes() {
      return this.paquetes.filter(p => p.estatus === 'pendiente_requisicion')
    },

    paquetesFiltrados() {
      if (!this.filtroPaquetes) return this.paquetes
      return this.paquetes.filter(p => p.estatus === this.filtroPaquetes)
    },

    resumenPaquetes() {
      const iconos = { pendiente_requisicion: 'mdi-package-variant', en_proceso: 'mdi-progress-clock', pagado: 'mdi-cash-check' }
      return ['pendiente_requisicion', 'en_proceso', 'pagado'].map(estatus => {
        const lista = this.paquetes.filter(p => p.estatus === estatus)
        return {
          estatus,
          icon: iconos[estatus],
          cantidad: lista.length,
          monto: lista.reduce((suma, p) => suma + (Number(p.monto) || 0), 0),
        }
      })
    },

    paqueteDetalle() {
      return this.paquetes.find(p => p.id === this.detalle.id) || null
    },

    datosPaquete() {
      const p = this.paqueteDetalle
      if (!p) return []
      return [
        { titulo: 'Fecha de aceptación', valor: this.formatoFechaHora(p.fecha) },
        { titulo: 'Comisiones', valor: p.cantidad },
        { titulo: 'Monto', valor: this.moneda(p.monto) },
        { titulo: 'Requisición', valor: p.id_requisicion ? `#${p.id_requisicion} · ${p.requisicion_estatus || 'Sin estatus'}` : 'Sin requisición' },
      ]
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    mensaje(error, porDefecto) {
      return error.response && error.response.data && error.response.data.message ? error.response.data.message : porDefecto
    },

    async initialize() {
      this.cargando = true
      try {
        const [{ data }, { data: dataPaquetes }] = await Promise.all([
          this.$http.post('ceaa.reporte.kpi'),
          this.$http.post('ceaa.paquetes.kpi'),
        ])
        this.contactos = Array.isArray(data.contactos) ? data.contactos : []
        this.paquetes = Array.isArray(dataPaquetes.paquetes) ? dataPaquetes.paquetes : []
      } catch (error) {
        this.contactos = []
        this.paquetes = []
        this.validarError(this.mensaje(error, 'No se pudo cargar el reporte'))
      } finally {
        this.cargando = false
      }
    },

    verPaquete(id) {
      this.detalle = { visible: true, id: Number(id) }
    },

    async generarRequisicion() {
      this.generando = true
      try {
        const { data } = await this.$http.post('ceaa.paquete.requisicion', { id_paquete: this.detalle.id })
        this.confirmacion = false
        this.validarSuccess(data.message)
        await this.initialize()
      } catch (error) {
        this.validarError(this.mensaje(error, 'No se pudo generar la requisición'))
      } finally {
        this.generando = false
      }
    },

    textoPaquete(estatus) {
      if (estatus === 'pagado') return 'Pagado'
      if (estatus === 'en_proceso') return 'En proceso de pago'
      return 'Pendiente de requisición'
    },

    colorPaquete(estatus) {
      if (estatus === 'pagado') return 'green'
      if (estatus === 'en_proceso') return 'orange darken-1'
      return 'blue-grey'
    },

    textoDecision(decision) {
      if (decision === 'aceptada') return 'Aceptada'
      if (decision === 'rechazada') return 'Rechazada'
      return 'Pendiente'
    },

    colorDecision(decision) {
      if (decision === 'aceptada') return 'green'
      if (decision === 'rechazada') return 'red'
      return 'grey'
    },

    moneda(valor) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(valor) || 0)
    },

    formatoFecha(valor) {
      if (!valor) return '—'
      const [anio, mes, dia] = String(valor).substr(0, 10).split('-')
      return dia && mes && anio ? `${dia}/${mes}/${anio}` : String(valor)
    },

    formatoFechaHora(valor) {
      if (!valor) return '—'
      const hora = String(valor).substr(11, 5)
      return `${this.formatoFecha(valor)}${hora ? ' ' + hora : ''}`
    },
  },
}
</script>

<style scoped>
.fila-clic >>> tbody tr {
  cursor: pointer;
}

.resumen-card {
  border-radius: 10px !important;
  cursor: pointer;
}

.resumen-card--activa {
  border-color: var(--v-primary-base) !important;
  border-width: 2px !important;
}
</style>
